// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { equipmentModelId } from './EquipmentModel';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentorModelCalibrationTargetId = (z.number());
export const fermentorModelCalibrationTarget = z.object({
    id: fermentorModelCalibrationTargetId,
    equipment_model_id: equipmentModelId,
    key: z.string(),
    label: z.string(),
    routine: z.string(),
    params_template: z.unknown(),
    editable_keys: z.string().array(),
    display_order: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const fermentorModelCalibrationTargetInitializer = z.object({
    id: fermentorModelCalibrationTargetId.optional(),
    equipment_model_id: equipmentModelId,
    key: z.string(),
    label: z.string(),
    routine: z.string(),
    params_template: z.unknown().optional(),
    editable_keys: z.string().array().optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const fermentorModelCalibrationTargetMutator = z.object({
    id: fermentorModelCalibrationTargetId.optional(),
    equipment_model_id: equipmentModelId.optional(),
    key: z.string().optional(),
    label: z.string().optional(),
    routine: z.string().optional(),
    params_template: z.unknown().optional(),
    editable_keys: z.string().array().optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentorModelCalibrationTarget.js.map